// @flow
import React, { Fragment } from "react";
import { withGlobalContext } from "../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";
import Color from "color";
import type { $SiteUser } from "flow/types";

import ArrowDropDown from "elevate-ui-icons/ArrowDropDown";

type $Props = {
  classes: Object,
  headerNav: string,
  onToggleDropdown: Function,
  openDropdowns: Object,
  siteUser: $SiteUser,
};

const MobileLoginLinks = ({
  classes,
  headerNav,
  onToggleDropdown,
  openDropdowns,
  siteUser,
}: $Props) => {
  if (!(siteUser && siteUser.id) && headerNav !== "default") {
    return (
      <Fragment>
        <li className={classes.mobileOnly}>
          <a href="/login">Login</a>
        </li>
        <li className={classes.mobileOnly}>
          <a href="/signup">Signup</a>
        </li>
      </Fragment>
    );
  }

  return (
    <li className={classes.mobileOnly}>
      <ul className={classes.accountToggle}>
        <li>
          <button
            className={classes.dropdownButton}
            onClick={(e) => onToggleDropdown(e, "account")}
          >
            {siteUser && siteUser.firstName
              ? siteUser.firstName
              : "My Account "}
            <ArrowDropDown />
          </button>
          {openDropdowns.account ? (
            <ul className={classes.navDropdown}>
              <li>
                <a href="/saved-searches">Saved Searches</a>
              </li>
              <li>
                <a href="/favorites">Favorites</a>
              </li>
              <li>
                <a href="/account">Account</a>
              </li>
              <li>
                <a href="/logout">Logout</a>
              </li>
            </ul>
          ) : null}
        </li>
      </ul>
    </li>
  );
};

const styles = (theme) => {
  const hoverColor = Color(theme.colors.primary["500"])
    .darken(0.5)
    .string();
  return {
    mobileOnly: {
      [theme.breakpoints(900)]: {
        display: "none",
      },
    },
    accountToggle: {
      listStyleType: "none",
      color: theme.colors.primaryFontColor,
      padding: "0",
      marginTop: (props) =>
        props.headerNav === "default"
          ? theme.spacing.unit * 0.5
          : theme.spacing.unit * 0.75,
      marginBottom: (props) =>
        props.headerNav === "default"
          ? theme.spacing.unit * 0.5
          : theme.spacing.unit * 0.75,
      backgroundColor: "transparent",
      "&:hover, &:focus": {
        textDecoration: "none",
        backgroundColor: hoverColor,
      },
      "& > li": {
        display: "block",
        position: "relative",
        marginRight: "0",
        padding: "6px 16px",
        fontSize: (props) => (props.headerNav === "default" ? "1em" : "14px"),
        color: theme.colors.primaryFontColor,
        borderColor: theme.colors.primary["500"],
        cursor: "default",
        "& > ul": {
          left: "unset",
          right: "0",
        },
      },
    },
    navDropdown: {
      color: theme.colors.primaryFontColor,
      position: "static",
      float: "none",
      width: "auto",
      marginTop: "0",
      backgroundColor: "transparent",
      border: "0",
      display: "block",
      left: "15px",
      top: "90%",
      zIndex: theme.zIndex.tooltip,
      minWidth: "160px",
      padding: "5px 0",
      margin: "2px 0 0",
      fontSize: "14px",
      textAlign: "left",
      listStyle: "none",
      [theme.breakpoints(900)]: {
        position: "absolute",
        backgroundColor: theme.colors.primary["500"],
        float: "right",
        border: theme.borders["default"],
        borderRadius: theme.globalBorderRadius,
        boxShadow: "0 6px 12px rgba(0,0,0,.175)",
      },
      "& li a": {
        color: theme.colors.primaryFontColor,
        padding: "8px 16px",
        margin: "6 auto",
        lineHeight: "20px",
        display: "block",
        position: "relative",
        fontSize: "1em",
        "&:hover, &:focus": {
          textDecoration: "none",
          backgroundColor: hoverColor,
        },
      },
    },
    dropdownButton: {
      appearance: "none",
      "-webkit-appearance": "none",
      backgroundColor: "transparent",
      border: "none",
      fontSize: "18px",
    },
  };
};

export default withGlobalContext(withStyles(styles)(MobileLoginLinks));
